
import React from 'react';

import { Icon, IconCountDown } from '../../../base/icons';

/**
 * Returns web element to be rendered.
 *
 * @param {string} timerValue - String to display as time.
 * @param {boolean} countdown - Whether the timer is counting down.
 *
 * @returns {ReactElement}
 */
export default function renderConferenceTimer(timerValue: string, countdown: boolean = false) {
    return countdown ? <span className = 'subject-conference-timer'><Icon src = { IconCountDown } />{timerValue}</span> : <span className = 'subject-conference-timer'>{`( ${timerValue} )`}</span>;
}
